import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "interface",
  "use": "interface-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"interface\"><path d=\"M0 1v14a1 1 0 001 1h14a1 1 0 001-1V1a1 1 0 00-1-1H1a1 1 0 00-1 1zm13.822 12.822h-.729v-3.644h-1.457v3.644h-.73v-3.644H9.459v3.644h-.73v-3.644H7.272v3.644h-.729v-3.644H5.093v3.644h-.729v-3.644H2.907v3.644h-.73V5.093h2.187V2.178h7.272v2.915h2.186v8.73z\" fill=\"#DB0000\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id